import { MESSAGE_LAYOUT_TRANSITION_EASING, MESSAGE_LAYOUT_TRANSITION_MS } from '../styles'

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const playFlipTranslateY = (element: HTMLElement, deltaY: number): void => {
  if (Math.abs(deltaY) < 1) {
    return
  }

  element.style.transition = 'none'
  element.style.transform = `translateY(${deltaY}px)`
  // Force reflow so the browser applies the initial transform before transitioning.
  element.getBoundingClientRect()
  element.style.transition = `transform ${MESSAGE_LAYOUT_TRANSITION_MS}ms ${MESSAGE_LAYOUT_TRANSITION_EASING}`
  element.style.transform = 'translateY(0)'

  const handleEnd = (event: TransitionEvent): void => {
    if (event.propertyName !== 'transform') {
      return
    }
    element.style.transition = ''
    element.style.transform = ''
    element.removeEventListener('transitionend', handleEnd)
  }
  element.addEventListener('transitionend', handleEnd)
}
